import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.multicloud.ninne.training';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: (username, password) => 
    api.post('/auth/login', { username, password }),
  
  createAdmin: (username, password) => 
    api.post('/auth/create-admin', { username, password }),
};

// Clouds API
export const cloudsAPI = {
  getClouds: () => api.get('/clouds'),
};

// Inventory API
export const inventoryAPI = {
  getResources: (cloud, params = {}) => 
    api.get(`/inventory/${cloud}`, { params }),
  
  getStats: (cloud) => 
    api.get(`/inventory/${cloud}/stats`),
};

export default api; 